import React from 'react';
import { Box, Text, Button, TextButton } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { useAtomValue } from 'jotai';
import { availableDomainAtom } from '../../atoms';
import { CardLayout } from '../../../../components/layouts/CardLayout';
import { ArrowRight, Gift } from 'wix-ui-icons-common';
import { ChevronRightSmall } from '@wix/wix-ui-icons-common';
import { useDomainLogic } from '../../hooks/useDomainLogic';
import { useBiLogger } from '../../../../hooks/useBiLogger/useBiLogger';
import { BI_CONSTANTS } from '../../../../hooks/useBiLogger/biConstants';

export function DomainSide() {
  const { t } = useTranslation();
  const availableDomain = useAtomValue(availableDomainAtom);
  const { onContinue } = useDomainLogic();
  const biLogger = useBiLogger();

  const onContinueClicked = () => {
    biLogger.actionClicked({
      action: BI_CONSTANTS.ACTION.DOMAIN_PAGE_NEXT,
      button_name: BI_CONSTANTS.BUTTON_NAME.NEXT,
      value: availableDomain,
    });
    onContinue({});
  };

  const onSkipClicked = () => {
    biLogger.actionClicked({
      action: BI_CONSTANTS.ACTION.DOMAIN_PAGE_SKIP,
      button_name: BI_CONSTANTS.BUTTON_NAME.SKIP,
    });
    onContinue({ skip: true });
  };

  return (
    <Box direction="vertical" gap={4}>
      <CardLayout gap={3}>
        {availableDomain && (
          <Text weight="bold" skin="success" size="medium">
            {t('DOMAIN_PAGE_DOMAIN_IS_AVAILABLE', { domain: availableDomain })}
          </Text>
        )}
        <Box verticalAlign="top" gap={2}>
          <Text skin="premium">
            <Gift />
          </Text>
          <Text>
            <Trans i18nKey="DOMAIN_PAGE_PREMIUM_VOUCHER" components={{ p: <Text skin="premium" /> }} />
          </Text>
        </Box>
        <Button
          fullWidth
          suffixIcon={<ArrowRight />}
          onClick={onContinueClicked}
          disabled={!availableDomain}
          size="large"
        >
          {t('DOMAIN_PAGE_CONTINUE_BUTTON')}
        </Button>
      </CardLayout>
      <Box align="center">
        <TextButton onClick={onSkipClicked} suffixIcon={<ChevronRightSmall />} size="small" skin="dark">
          {t('DOMAIN_PAGE_SKIP_BUTTON')}
        </TextButton>
      </Box>
    </Box>
  );
}
